import { useQuery } from '@tanstack/react-query'
import { getDashboardStats } from '../services/api.js'
import MyDay from '../components/dashboard/MyDay.jsx'
import MyCommissions from '../components/dashboard/MyCommissions.jsx'
import DashboardStatsGrid from '../components/dashboard/DashboardStatsGrid.jsx'
import DetailedStats from '../components/dashboard/DetailedStats.jsx'
import RecentActivity from '../components/dashboard/RecentActivity.jsx'
import QuickActions from '../components/dashboard/QuickActions.jsx'
import QuickStats from '../components/dashboard/QuickStats.jsx'

export default function Dashboard() {
  const { data: stats, isLoading } = useQuery({
    queryKey: ['dashboardStats'],
    queryFn: getDashboardStats,
    staleTime: 30000,
  })

  const dashStats = stats?.stats || {}

  return (
    <div className="view-container active flex flex-col gap-6" data-view="home">
      <MyDay />

      <h2 className="mt-2 text-sm font-bold uppercase tracking-[0.1em] text-foreground-secondary">Vos chiffres</h2>
      <MyCommissions />

      <DashboardStatsGrid stats={dashStats} isLoading={isLoading} />
      
      <div className="main-content-grid">
        <DetailedStats stats={dashStats} isLoading={isLoading} />
        <RecentActivity activity={dashStats.recentActivity} isLoading={isLoading} />
        <QuickActions />
        <QuickStats stats={dashStats} isLoading={isLoading} />
      </div>
    </div>
  )
}
